
import Vue from "vue";
import PreparingCourseware from "components/PreparingCourseware.vue";
export default Vue.extend({
  name: "EnclosureQuestion",
  components: {
    PreparingCourseware
  },
  props: {
    courseId: {
      type: String,
      default: ""
    },
    paperId: {
      type: String,
      default: ""
    },
    /* --------------------------跳转页面参数----------------------------- */
    paperType: {
      type: String,
      default: "Paper"
    },
    faceId: {
      type: String,
      default: ""
    },
    classId: {
      type: String,
      default: ""
    }
    // faceTeachState: {
    //   type: String,
    //   default: ""
    // },
    /* ------------------------------------------------------------------- */
  },
  data() {
    return {
      docId: "",
      content: {},
      fileList: [], // 无用
      title: "",
      desceiption: "",
      //   urlAliyunOSS: '/api/design/osssign/getsign',
      fileIds: [], // 附件Id
      filesList: [],
      // 是否展示富文本框
      isShowEditor: true,
      isShowInput: false,
      dialogVisiblePreviewResources: false,
    };
  },
  watch: {},
  created() {
    this.getEnclosureQuestion();
  },
  methods: {
    dialogClose() {
      this.dialogVisiblePreviewResources = false;
    },
    // 返回上级
    goback: function() {
      this.$router.go(-1);
    },
    handleRemove(file, fileList) {},
    handlePreview (docId) {
      this.docId = docId;
      this.dialogVisiblePreviewResources = true;
    },
    getEnclosureQuestion: function() {
      this.$http.post('/api/XOrg/BookMaterial/geEnclosureInfoById',{
        paperId: this.paperId
      }).then(rst => {
        this.title = rst.info.Title;
        this.desceiption = rst.info.Descriptioin;
        this.filesList = rst.info.FileList;
      });
    },
    addEnclosureQuestion: function() {
     this.$http.post('/api/XOrg/BookMaterial/editEnclosurePaperById',{
        paperId: this.paperId, 
        title: this.title, 
        desceiption: this.desceiption, 
        fileIds: this.fileIds
      }).then(rst => {
        if (rst.code > 0) {
          this.$message.success(rst.msg);
        } else {
          this.$message.warning(rst.msg);
        }
      });
    },
    Preview: function(data) {
      this.isShowEditor = !data;
    },
    hideTitleInput: function() {
      this.isShowInput = false;
      this.updatePaperName();
    },
    updatePaperName: function() {
      this.$http.post('/api/XOrg/BookMaterial/updatePaperName',{
        paperId: this.paperId, 
        paperName: this.title, 
      }).then(rst => {
        if (rst.code > 0) {
          this.$message.success(rst.msg);
        } else {
          this.$message.warning(rst.msg);
        }
      });
    }
  }
});
